// import { gsap } from 'gsap';
// // import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
// import { CSSRulePlugin } from 'gsap/CSSRulePlugin'
// gsap.registerPlugin( ScrollTrigger, DrawSVGPlugin);
gsap.defaults({ ease: 'none', duration: 1 });
ScrollTrigger.defaults({scrub: true, start: 'top center', end: 'bottom center'});

let paths = document.getElementById("paths");
const processLineContainer = document.querySelector('#processLineContainer');
const processLineCollection = document.querySelectorAll('.process-line-item');

var count_of_lines = processLineCollection.length;
var smallScreenBreakpoint = 576;

for(let x=1; x < count_of_lines; x++) {
    if(!paths) continue;
    let path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("class", "path");
    path.setAttribute("id", "path"+x);
    paths.appendChild(path);
}

window.addEventListener('load', (event) => {

  gsap.to(".image-background-block .fixed-bg-img", {
      top: "200px",
      ease: "none",
      scrollTrigger: {
        trigger: ".gradient-block",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      }
  });

// var ro = new ResizeObserver(entries => {
//   for (let entry of entries) {
    let isSmallScreen = (window.innerWidth <= smallScreenBreakpoint) ? true : false;

    for(let x = 1; x < count_of_lines; x++) {

        const direction = (x % 2 == 0);
        const line = document.getElementById("path"+x);

        let d1 = document.getElementById('DotLayer_'+x);
        let d1pos = getCenterCoords(d1);

        let d2 = document.getElementById('DotLayer_'+(x+1));
        let d2pos = getCenterCoords(d2);

        line.setAttribute('d', createLine([d1pos.xCenter, d1pos.yCenter], [d2pos.xCenter, d2pos.yCenter], direction));
    }

    gsap.timeline({defaults: {duration: 1}, 
      scrollTrigger: {
        trigger: '#DotLayer_1',
        start: 'center+=50px center',
        end: 'center+=100px center'
      },
    })
    .fromTo("#DotLayer_1", {duration: .2, scale: 0, transformOrigin:'center'}, {scale: 1})
    
    for(let x = 1; x < count_of_lines; x++) {
    // LINE 1 (intro)
    let t = x+1;
    let directional = ((x % 2 != 0) || isSmallScreen) ? 1000 : -1000;
    gsap.timeline({defaults: {duration: 1}, 
      scrollTrigger: {
        trigger: '#DotLayer_'+x,
        start: 'top-=150px top',
        end: '+=400'
      },
    })
    .from('#path'+x, { drawSVG: 0 })
    .fromTo("#DotLayer_"+t, { scale: 0, transformOrigin:'center'}, {duration: .2,scale: 1});
    
    gsap.timeline({defaults: {duration: 1}, 
      scrollTrigger: {
        trigger: "#pl-item-"+t,
        start: 'top+=350px bottom',
        end: '+=250'
      },
    })
    .fromTo("#pl-item-"+t+" .process-content", {opacity: 0}, {duration: 300, opacity: 1})
    // .fromTo("#pl-item-"+t+" .icon", {opacity: 0}, {duration: 100, opacity: 1})
    .fromTo("#pl-item-"+t+" .process-item-title", {opacity: 0, x: directional}, {duration: 200, delay:200, opacity: 1, x:0})
    .fromTo("#pl-item-"+t+" li", {opacity: 0, x: directional}, {opacity: 1, duration: 200, x:0, delay:100, stagger:100})
    .fromTo("#pl-item-"+t+" .btn", {opacity: 0}, {opacity: 1, duration: 200, delay:100})
    }
  // }
// });
});

// Observe one or multiple elements
// if(processLineCollection){
// ro.observe(processLineContainer);
// }

function getCenterCoords(element) {
  const box = element.getBoundingClientRect();
  const ret = {};

  ret.xCenter = element.offsetLeft + element.offsetWidth / 2;
  ret.yCenter = element.offsetTop + element.offsetHeight / 2;

  return ret;
}

function createLine(source, target, reverse = false){
  let isSmallScreen = (window.innerWidth <= smallScreenBreakpoint) ? true : false;
  var dx = target[0] - source[0],
      dy = target[1] - source[1],
      dr = Math.sqrt(dx * dx + dy * dy)/1.25;

      // reverses curve on alternating lines
    let direction = (reverse) ? dr + "," + dr + ' 1 0,0 ' : dr + "," + dr + ' 0 0,1 ';

    // curve only for larger screens
    let curve = (isSmallScreen) ? '0,0 0 0,0' : direction;
  
  return "M" +
    source[0] + "," +
    source[1] + "A" +
    curve +
    target[0] + "," +
    target[1];
}










